"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageLocal = void 0;
exports.StorageLocal = new (class {
    remove(key) {
        localStorage.removeItem(key);
    }
    set(key, value) {
        localStorage.setItem(key, String(value));
    }
    get(key) {
        const value = localStorage.getItem(key);
        return value === null ? undefined : value;
    }
    getNumber(key) {
        const value = localStorage.getItem(key);
        return value === null ? undefined : Number(value);
    }
    setBoolean(key, value) {
        localStorage.setItem(key, String(value));
    }
    getBoolean(key) {
        const value = localStorage.getItem(key);
        return value === null ? undefined : value === 'true';
    }
    clear() {
        localStorage.clear();
    }
    clearExcept(preservePatterns) {
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && !preservePatterns.some((pattern) => key.includes(pattern))) {
                keysToRemove.push(key);
            }
        }
        keysToRemove.forEach((key) => localStorage.removeItem(key));
    }
})();
